var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('el-select',{attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"size":"small"},model:{value:(_vm.selectId),callback:function ($$v) {_vm.selectId=$$v},expression:"selectId"}},_vm._l((_vm.dicList),function(item){return _c('el-option',{key:item.dicId,attrs:{"label":item.cnName,"value":item.dicId}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }